import md5 from 'js-md5';
import addinstance from './instance.js'
import geturl from './seturl'
//管理员列表
export const adminlist= params=> {return addinstance().get(geturl(`/admin/index`),{params:params});}
//管理员删除
export const deleteadmin= params => {return addinstance().post(geturl(`/admin/delete`), params) };
//管理员基础信息修改
export const updateadmin= params => { 
    if(params.password){
        params.password=md5(params.password)
    }
    return addinstance().post(geturl(`/admin/update`), params) };
//添加管理员
export const createadmin= params => {
    if(params.password){
        params.password=md5(params.password)
    } 
    return addinstance().post(geturl(`/admin/create`), params) };
//管理员详情
export const admindetail= params=> {return addinstance().get(geturl(`/admin/detail`),{params:params});}
//锁定
export const lockadmin= params => { return addinstance().post(geturl(`/admin/lock`), params) };
//检查管理员的用户名是否可用
export const usernameadmin= params => { return addinstance().post(geturl(`/admin/username`), params) };
export const adminlog= params=> {return addinstance().get(geturl(`/admin/log`),{params:params});}








// WEBPACK FOOTER //
// ./src/api/adminapi.js